import React from 'react';
import { reviews } from '../data/content';
import Icon from './Icons';
import Reveal from './Reveal';
import './Reviews.css';

/**
 * Recenzie zákazníkov.
 * Novú recenziu pridáš v src/data/content.js – skopíruj blok { ... }
 * v poli `reviews` a uprav text. Zobrazia sa automaticky.
 */
export default function Reviews() {
  return (
    <section className="section section--gray" id="recenzie">
      <div className="container">
        <Reveal className="section-heading">
          <span className="eyebrow">Recenzie</span>
          <h2>Čo hovoria naši zákazníci</h2>
        </Reveal>

        <div className="reviews">
          {reviews.map((review, index) => (
            <Reveal key={`${review.name}-${index}`} delay={Math.min(index * 0.08, 0.32)}>
              <figure className="review">
                <div className="review__stars" aria-label={`Hodnotenie ${review.rating} z 5`}>
                  {Array.from({ length: review.rating }).map((_, starIndex) => (
                    <Icon key={starIndex} name="star" size={16} />
                  ))}
                </div>
                <blockquote>„{review.text}“</blockquote>
                <figcaption>
                  <img src={review.photo} alt="" loading="lazy" />
                  <span>
                    <strong>{review.name}</strong>
                    <small>{review.date}</small>
                  </span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
